import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming It Without Blaming Myself",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I’m not “broken.” Today I simply notice: it’s hard for me to open up."
    ],
      [
      "Daily intention: Today I’m not “broken.” Today I simply notice: it’s hard for me to open up."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “My closedness is protection, not a defect.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “My closedness is protection, not a defect.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. When do I feel myself “closing” on dates?\n[Write here]",
      "2. What am I afraid they will see in me if I open?\n[Write here]",
      "3. Where in my body do I feel this closedness?\n[Write here]"
    ],
      [
      "1. When do I feel myself “closing” on dates?\n[Write here]",
      "2. What am I afraid they will see in me if I open?\n[Write here]",
      "3. Where in my body do I feel this closedness?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Today I don’t fight it. I’m learning to recognize my protection gently."
    ],
      [
      "Closing",
      "Today I don’t fight it. I’m learning to recognize my protection gently."
    ]
    ),
    action: localizedGenderNode(
      "Once today: one breath + the sentence: “I’m allowed to open slowly.”",
      "Once today: one breath + the sentence: “I’m allowed to open slowly.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What Exactly Happens in the Moment I Close",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice the small moment when I shift."
    ],
      [
      "Daily intention: Today I notice the small moment when I shift."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I’m observing, not judging.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I’m observing, not judging.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What is the common trigger that closes me? (a question, a look, silence, touch, expectation)\n[Write here]",
      "2. What is the first thought that jumps in?\n[Write here]",
      "3. What do I do immediately after? (humor, changing the topic, distancing, phone)\n[Write here]"
    ],
      [
      "1. What is the common trigger that closes me? (a question, a look, silence, touch, expectation)\n[Write here]",
      "2. What is the first thought that jumps in?\n[Write here]",
      "3. What do I do immediately after? (humor, changing the topic, distancing, phone)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When I recognize the moment — a choice already begins."
    ],
      [
      "Closing",
      "When I recognize the moment — a choice already begins."
    ]
    ),
    action: localizedGenderNode(
      "Next time I close: a 10-second pause before I “escape.”",
      "Next time I close: a 10-second pause before I “escape.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Fear Underneath (Rejection / Shame / Being Exposed)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I identify the real fear under my closedness."
    ],
      [
      "Daily intention: Today I identify the real fear under my closedness."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “My fear is trying to protect me.”"
    ],
      [
      "I pause with myself.",
      "One breath. “My fear is trying to protect me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I fear more: being rejected, being hurt, or being seen?\n[Write here]",
      "2. What old sentence do I believe about love/relationship?\n[Write here]",
      "3. What gentler sentence can replace it today?\n[Write here]"
    ],
      [
      "1. What do I fear more: being rejected, being hurt, or being seen?\n[Write here]",
      "2. What old sentence do I believe about love/relationship?\n[Write here]",
      "3. What gentler sentence can replace it today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Fear doesn’t have to disappear for me to be a little more real."
    ],
      [
      "Closing",
      "Fear doesn’t have to disappear for me to be a little more real."
    ]
    ),
    action: localizedGenderNode(
      "I write one gentle sentence and keep it: “I can be me, slowly.”",
      "I write one gentle sentence and keep it: “I can be me, slowly.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "“Opening Up” Doesn’t Mean Sharing Everything",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I define openness in a safe way."
    ],
      [
      "Daily intention: Today I define openness in a safe way."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Openness can be small.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Openness can be small.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What is “safe openness” for me? (one example)\n[Write here]",
      "2. What is “too much openness” for me?\n[Write here]",
      "3. What healthy boundary would help me feel protected?\n[Write here]"
    ],
      [
      "1. What is “safe openness” for me? (one example)\n[Write here]",
      "2. What is “too much openness” for me?\n[Write here]",
      "3. What healthy boundary would help me feel protected?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to open fast. I build trust at my pace."
    ],
      [
      "Closing",
      "I don’t have to open fast. I build trust at my pace."
    ]
    ),
    action: localizedGenderNode(
      "I choose one small thing to share next time — no more.",
      "I choose one small thing to share next time — no more."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The Body on Dates (Freeze / Tension / Detachment)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I listen to my body instead of fighting it."
    ],
      [
      "Daily intention: Today I listen to my body instead of fighting it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath. “The body speaks.”"
    ],
      [
      "I pause with myself.",
      "One slow breath. “The body speaks.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. How does my body behave on a date? (frozen/tense/contracted/too polite)\n[Write here]",
      "2. What is my body asking from me in that moment? (air, space, a pause, water)\n[Write here]",
      "3. What small action would help my body calm down?\n[Write here]"
    ],
      [
      "1. How does my body behave on a date? (frozen/tense/contracted/too polite)\n[Write here]",
      "2. What is my body asking from me in that moment? (air, space, a pause, water)\n[Write here]",
      "3. What small action would help my body calm down?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When I calm my body — my heart gets space."
    ],
      [
      "Closing",
      "When I calm my body — my heart gets space."
    ]
    ),
    action: localizedGenderNode(
      "“Low breath” practice: 3 belly breaths, once.",
      "“Low breath” practice: 3 belly breaths, once."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Inner Voice That Criticizes Me on Dates",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I replace criticism with a voice that holds me."
    ],
      [
      "Daily intention: Today I replace criticism with a voice that holds me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I don’t have to prove.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I don’t have to prove.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What critical sentence repeats in me?\n[Write here]",
      "2. How would I speak to a good friend in my place?\n[Write here]",
      "3. How does that sentence sound in a gentle version?\n[Write here]"
    ],
      [
      "1. What critical sentence repeats in me?\n[Write here]",
      "2. How would I speak to a good friend in my place?\n[Write here]",
      "3. How does that sentence sound in a gentle version?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A gentle voice doesn’t make me weak. It lets me be real."
    ],
      [
      "Closing",
      "A gentle voice doesn’t make me weak. It lets me be real."
    ]
    ),
    action: localizedGenderNode(
      "Once today: I answer the criticism with my gentle sentence.",
      "Once today: I answer the criticism with my gentle sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Clean Exposure (Gentle ACT): Staying One More Minute",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice staying inside discomfort without running away."
    ],
      [
      "Daily intention: Today I practice staying inside discomfort without running away."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I can hold a minute.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I can hold a minute.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. In which moment do I tend to run?\n[Write here]",
      "2. If I stay one more minute — what do I fear will happen?\n[Write here]",
      "3. What happened in reality when I stayed one more minute (even in imagination)?\n[Write here]"
    ],
      [
      "1. In which moment do I tend to run?\n[Write here]",
      "2. If I stay one more minute — what do I fear will happen?\n[Write here]",
      "3. What happened in reality when I stayed one more minute (even in imagination)?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Courage is not huge openness. Courage is one more minute."
    ],
      [
      "Closing",
      "Courage is not huge openness. Courage is one more minute."
    ]
    ),
    action: localizedGenderNode(
      "Next time: “one more minute” before I close.",
      "Next time: “one more minute” before I close."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Setting Boundaries Without Closing",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I learn: a boundary can be open."
    ],
      [
      "Daily intention: Today I learn: a boundary can be open."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “A boundary is protection, not a wall.”"
    ],
      [
      "I pause with myself.",
      "One breath. “A boundary is protection, not a wall.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where do I need a boundary in dating?\n[Write here]",
      "2. How can I say a boundary softly?\n[Write here]",
      "3. What fear surrounds setting a boundary?\n[Write here]"
    ],
      [
      "1. Where do I need a boundary in dating?\n[Write here]",
      "2. How can I say a boundary softly?\n[Write here]",
      "3. What fear surrounds setting a boundary?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When there is a boundary — armor is less needed."
    ],
      [
      "Closing",
      "When there is a boundary — armor is less needed."
    ]
    ),
    action: localizedGenderNode(
      "I prepare one soft boundary sentence for future use.",
      "I prepare one soft boundary sentence for future use."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Who I Am When I’m Not “Performing”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I release performance and bring back humanity."
    ],
      [
      "Daily intention: Today I release performance and bring back humanity."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I am not a show.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I am not a show.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What am I trying to “look like” on a date?\n[Write here]",
      "2. What happens to me when I try to impress?\n[Write here]",
      "3. What one human truth am I willing to bring?\n[Write here]"
    ],
      [
      "1. What am I trying to “look like” on a date?\n[Write here]",
      "2. What happens to me when I try to impress?\n[Write here]",
      "3. What one human truth am I willing to bring?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "People connect to truth, not to perfection."
    ],
      [
      "Closing",
      "People connect to truth, not to perfection."
    ]
    ),
    action: localizedGenderNode(
      "I practice one simple sentence: “Honestly, it’s a bit hard for me to open slowly.”",
      "I practice one simple sentence: “Honestly, it’s a bit hard for me to open slowly.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Trust Is Built in Small Portions",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I’m not looking for a “spark.” I’m building trust."
    ],
      [
      "Daily intention: Today I’m not looking for a “spark.” I’m building trust."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Trust is a process.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Trust is a process.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What makes me feel safe with a person?\n[Write here]",
      "2. What is one small sign that shows me this is a safe person?\n[Write here]",
      "3. What is one small sign that shows me it’s not?\n[Write here]"
    ],
      [
      "1. What makes me feel safe with a person?\n[Write here]",
      "2. What is one small sign that shows me this is a safe person?\n[Write here]",
      "3. What is one small sign that shows me it’s not?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to open to someone who doesn’t feel safe."
    ],
      [
      "Closing",
      "I don’t have to open to someone who doesn’t feel safe."
    ]
    ),
    action: localizedGenderNode(
      "I write 2 “safe” signs and 2 “not safe” signs and keep them.",
      "I write 2 “safe” signs and 2 “not safe” signs and keep them."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Asking a Real Question Instead of Hiding",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I create connection through curiosity, not effort."
    ],
      [
      "Daily intention: Today I create connection through curiosity, not effort."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Curiosity opens gently.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Curiosity opens gently.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What would I truly like to know about the person in front of me?\n[Write here]",
      "2. What is one simple question I can ask?\n[Write here]",
      "3. What am I afraid to ask and why?\n[Write here]"
    ],
      [
      "1. What would I truly like to know about the person in front of me?\n[Write here]",
      "2. What is one simple question I can ask?\n[Write here]",
      "3. What am I afraid to ask and why?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Openness is also asking, not only telling."
    ],
      [
      "Closing",
      "Openness is also asking, not only telling."
    ]
    ),
    action: localizedGenderNode(
      "I choose one “real” question for my next date.",
      "I choose one “real” question for my next date."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "When a Date “Doesn’t Work” Without Taking It on Myself",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate compatibility from self-worth."
    ],
      [
      "Daily intention: Today I separate compatibility from self-worth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Incompatibility is not rejection of who I am.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Incompatibility is not rejection of who I am.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I immediately interpret as failure?\n[Write here]",
      "2. What is another possible explanation, more neutral?\n[Write here]",
      "3. What do I want to remember about my worth even if it doesn’t work?\n[Write here]"
    ],
      [
      "1. What do I immediately interpret as failure?\n[Write here]",
      "2. What is another possible explanation, more neutral?\n[Write here]",
      "3. What do I want to remember about my worth even if it doesn’t work?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I am not measured by one date."
    ],
      [
      "Closing",
      "I am not measured by one date."
    ]
    ),
    action: localizedGenderNode(
      "After an interaction: I write 1 thing I did right.",
      "After an interaction: I write 1 thing I did right."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "“I’m Ready for Relationship” In My Meaning",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I phrase what I truly want in relationship."
    ],
      [
      "Daily intention: Today I phrase what I truly want in relationship."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I’m allowed to want a relationship that fits me.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I’m allowed to want a relationship that fits me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. How do I want to feel inside a relationship?\n[Write here]",
      "2. What one value must be there?\n[Write here]",
      "3. What one boundary will protect me in my next relationship?\n[Write here]"
    ],
      [
      "1. How do I want to feel inside a relationship?\n[Write here]",
      "2. What one value must be there?\n[Write here]",
      "3. What one boundary will protect me in my next relationship?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Clarity creates safety."
    ],
      [
      "Closing",
      "Clarity creates safety."
    ]
    ),
    action: localizedGenderNode(
      "I write one “direction sentence” for my next relationship and keep it.",
      "I write one “direction sentence” for my next relationship and keep it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure: Opening Slowly Is a Skill",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I close the journey with loyalty to myself."
    ],
      [
      "Daily intention: Today I close the journey with loyalty to myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath. “I’m not late. I’m accurate to myself.”"
    ],
      [
      "I pause with myself.",
      "One slow breath. “I’m not late. I’m accurate to myself.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What did I learn about my protection?\n[Write here]",
      "2. What one small step of openness am I willing to keep?\n[Write here]",
      "3. A return sentence for days of closing:\n[Write here]"
    ],
      [
      "1. What did I learn about my protection?\n[Write here]",
      "2. What one small step of openness am I willing to keep?\n[Write here]",
      "3. A return sentence for days of closing:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I don’t force myself to open.",
      "I teach myself to feel safe.",
      "Slowly, quietly, with myself.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I don’t force myself to open.",
      "I teach myself to feel safe.",
      "Slowly, quietly, with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "I choose one action that symbolizes “small openness”: a short honest message / a short conversation / one outing without pressure.",
      "I choose one action that symbolizes “small openness”: a short honest message / a short conversation / one outing without pressure."
    ),
  },
].map(buildNormalizedDay);

export const difficultyOpeningUpOnDatesBlueprintEn = buildNormalizedPilotBlueprint({
  id: "difficulty_opening_up_on_dates_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "difficulty_opening_up_on_dates",
  category: "general",
  journeyName: {
    he: "קושי להיפתח בדייטים",
    en: "Difficulty Opening Up on Dates",
    es: "Dificultad para abrirme en citas",
  },
  days,
});

export default difficultyOpeningUpOnDatesBlueprintEn;
